import type { ApiErrorCodeI18nPatternRule } from "./error-code-i18n-pattern-types";

// Runtime, execution, task-center, and business-event error-code i18n pattern rules.
export const API_ERROR_CODE_I18N_RUNTIME_BRIDGE_PATTERN_RULES: readonly ApiErrorCodeI18nPatternRule[] =
  [
    {
      prefix: "aitest.business_event.",
      resourceI18nKey: "common.errors.apiCodeResources.aitestBusinessEvent",
      reasonCodes: ["outbox_claim_failed", "publish_failed"],
    },
    {
      prefix: "aitest.experiment.",
      resourceI18nKey: "common.errors.apiCodeResources.aitestExperiment",
      reasonCodes: [
        "actor_username_required",
        "archived_immutable",
        "create_status_invalid",
        "delete_conflict",
        "invalid_status",
        "invalid_status_filter",
        "mode_immutable",
        "mode_invalid",
        "name_required",
        "not_found",
        "number_allocation_invalid",
        "number_sequence_exhausted",
        "owner_user_id_required",
        "regression_target_version_not_supported",
        "source_experiment_mode_invalid",
        "source_experiment_not_found",
        "source_target_mismatch",
        "source_task_execution_mode_invalid",
        "source_task_immutable",
        "source_task_not_completed",
        "source_task_not_confirmed",
        "source_task_not_found",
        "source_task_not_supported",
        "source_task_required",
        "status_update_forbidden",
        "target_immutable",
        "target_not_found",
        "target_version_immutable",
        "target_version_not_found",
        "target_version_required",
        "target_version_target_mismatch",
      ],
    },
    {
      prefix: "aitest.intelligent_runner.",
      resourceI18nKey: "common.errors.apiCodeResources.aitestIntelligentRunner",
      reasonCodes: ["callback_base_url_invalid", "callback_base_url_missing"],
    },
    {
      prefix: "aitest.orchestration.",
      resourceI18nKey: "common.errors.apiCodeResources.aitestOrchestration",
      reasonCodes: ["destroy_payload_kind_required", "submit_payload_kind_required"],
    },
    {
      prefix: "ctf.business_event.",
      resourceI18nKey: "common.errors.apiCodeResources.ctfBusinessEvent",
      reasonCodes: [
        "consumer_loop_failed",
        "contract_dead_lettered",
        "domain_dead_lettered",
        "inbox_failure_record_failed",
        "outbox_claim_failed",
        "programmer_error",
        "publish_failed",
        "retry_dead_lettered",
        "retry_later_dead_lettered",
      ],
    },
    {
      prefix: "exam.execution_fabric.",
      resourceI18nKey: "common.errors.apiCodeResources.examExecutionFabric",
      reasonCodes: ["invalid_error_response", "invalid_success_response", "request_failed"],
    },
    {
      prefix: "exam.task_center.",
      resourceI18nKey: "common.errors.apiCodeResources.examTaskCenter",
      reasonCodes: [
        "handoff_failed",
        "invalid_error_response",
        "invalid_success_response",
        "request_failed",
      ],
    },
    {
      prefix: "platform.asset_center.business_event.",
      resourceI18nKey: "common.errors.apiCodeResources.platformAssetCenterBusinessEvent",
      reasonCodes: [
        "consumer_loop_failed",
        "inbox_failure_record_failed",
        "outbox_claim_failed",
        "publish_failed",
      ],
    },
    {
      prefix: "platform.execution.asset_center.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionAssetCenter",
      reasonCodes: ["download_failed", "invalid_response", "request_failed"],
    },
    {
      prefix: "platform.execution.docker_image.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionDockerImage",
      reasonCodes: ["inspect_failed", "local_cleanup_failed", "upload_file_close_failed"],
    },
    {
      prefix: "platform.execution.docker_image_commit.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionDockerImageCommit",
      reasonCodes: ["async_publish_failed"],
    },
    {
      prefix: "platform.execution.environment_center.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionEnvironmentCenter",
      reasonCodes: ["invalid_response", "request_failed"],
    },
    {
      prefix: "platform.execution.environment_instance_submit.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionEnvironmentInstanceSubmit",
      reasonCodes: ["admission_lease_release_failed", "failed"],
    },
    {
      prefix: "platform.execution.execution_process_lock.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionExecutionProcessLock",
      reasonCodes: ["acquire_failed", "release_failed"],
    },
    {
      prefix: "platform.execution.execution_task_claim.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionExecutionTaskClaim",
      reasonCodes: ["runtime_node_freshness_touch_failed"],
    },
    {
      prefix: "platform.execution.execution_task_dispatch.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionExecutionTaskDispatch",
      reasonCodes: ["failed"],
    },
    {
      prefix: "platform.execution.execution_task_lease.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionExecutionTaskLease",
      reasonCodes: ["renew_failed"],
    },
    {
      prefix: "platform.execution.instance_task_reconciliation.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionInstanceTaskReconciliation",
      reasonCodes: ["task_center_routing_mismatch"],
    },
    {
      prefix: "platform.execution.kvm_image_commit.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionKvmImageCommit",
      reasonCodes: ["asset_upload_failed", "async_publish_failed"],
    },
    {
      prefix: "platform.execution.kvm_readiness.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionKvmReadiness",
      reasonCodes: [
        "ready_projection_retry",
        "ready_status_transition_retry",
        "runtime_sync_retry",
        "runtime_target_fetch_failed",
        "topology_projection_retry",
      ],
    },
    {
      prefix: "platform.execution.runtime_control_plane.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionRuntimeControlPlane",
      reasonCodes: ["heartbeat_rollback_failed"],
    },
    {
      prefix: "platform.execution.runtime_event.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionRuntimeEvent",
      reasonCodes: ["report_failed"],
    },
    {
      prefix: "platform.execution.runtime_execution_envelope.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionRuntimeExecutionEnvelope",
      reasonCodes: [
        "failure_patch_failed",
        "publish_failed",
        "release_claim_failed",
        "status_patch_failed",
      ],
    },
    {
      prefix: "platform.execution.runtime_instance_list.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionRuntimeInstanceList",
      reasonCodes: ["unreachable_target"],
    },
    {
      prefix: "platform.execution.runtime_pending_kick.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionRuntimePendingKick",
      reasonCodes: ["failed", "start_failed"],
    },
    {
      prefix: "platform.execution.runtime_target.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionRuntimeTarget",
      reasonCodes: ["request_failed", "request_retry"],
    },
    {
      prefix: "platform.execution.runtime_target_selection.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionRuntimeTargetSelection",
      reasonCodes: ["lookup_failed"],
    },
    {
      prefix: "platform.execution.runtime_worker_view.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionRuntimeWorkerView",
      reasonCodes: ["task_center_registry_read_failed", "task_center_registry_unavailable"],
    },
    {
      prefix: "platform.execution.task_center.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionTaskCenter",
      reasonCodes: ["invalid_response", "request_failed"],
    },
    {
      prefix: "platform.execution.topology_create_submit.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionTopologyCreateSubmit",
      reasonCodes: [
        "admission_lease_release_failed",
        "cross_node_admission_lease_release_failed",
        "cross_node_admission_leases_release_failed",
      ],
    },
    {
      prefix: "platform.execution.topology_destroy.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionTopologyDestroy",
      reasonCodes: ["projection_lock_conflict"],
    },
    {
      prefix: "platform.execution.topology_dispatch.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionTopologyDispatch",
      reasonCodes: ["failed"],
    },
    {
      prefix: "platform.execution.topology_orphan_repair.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionTopologyOrphanRepair",
      reasonCodes: ["task_close_failed"],
    },
    {
      prefix: "platform.execution.topology_submit_finalize.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionTopologySubmitFinalize",
      reasonCodes: [
        "ack_build_fallback",
        "deadlock",
        "deadlock_recovery_failed",
        "projection_lock_conflict",
        "rollback_failed",
      ],
    },
    {
      prefix: "platform.execution.topology_task_replay.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionTopologyTaskReplay",
      reasonCodes: ["projection_retry", "request_mismatch"],
    },
    {
      prefix: "platform.execution.traffic_library.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionTrafficLibrary",
      reasonCodes: ["invalid_response", "request_failed"],
    },
    {
      prefix: "platform.execution_fabric.business_event.aitest_submit_failure_projection.",
      resourceI18nKey:
        "common.errors.apiCodeResources.platformExecutionFabricBusinessEventAitestSubmitFailureProjection",
      reasonCodes: ["failed", "parse_failed", "unsupported_shape"],
    },
    {
      prefix: "platform.execution_fabric.business_event.ctf_orchestration.",
      resourceI18nKey:
        "common.errors.apiCodeResources.platformExecutionFabricBusinessEventCtfOrchestration",
      reasonCodes: ["submit_failed_writeback_queued"],
    },
    {
      prefix: "platform.execution_fabric.business_event.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionFabricBusinessEvent",
      reasonCodes: [
        "consumer_loop_failed",
        "contract_dead_lettered",
        "inbox_failure_mark_failed",
        "outbox_claim_failed",
        "programmer_error",
        "publish_failed",
        "retry_dead_lettered",
        "retry_scheduled",
        "unexpected_retry_dead_lettered",
        "unexpected_retry_scheduled",
      ],
    },
    {
      prefix: "platform.execution_fabric.instance_orchestration.",
      resourceI18nKey:
        "common.errors.apiCodeResources.platformExecutionFabricInstanceOrchestration",
      reasonCodes: ["reconcile_failed"],
    },
    {
      prefix: "platform.execution_fabric.stale_running_recovery.",
      resourceI18nKey: "common.errors.apiCodeResources.platformExecutionFabricStaleRunningRecovery",
      reasonCodes: ["rollback_failed", "sync_failed"],
    },
    {
      prefix: "platform.identity.platform_overview.",
      resourceI18nKey: "common.errors.apiCodeResources.platformIdentityPlatformOverview",
      reasonCodes: ["asset_remediation_invalid_payload", "health_status_invalid"],
    },
    {
      prefix: "platform.shared.redis_json_cache.",
      resourceI18nKey: "common.errors.apiCodeResources.platformSharedRedisJsonCache",
      reasonCodes: ["read_failed", "write_failed"],
    },
    {
      prefix: "platform.task_center.auto_retry.",
      resourceI18nKey: "common.errors.apiCodeResources.platformTaskCenterAutoRetry",
      reasonCodes: ["unexpected_dispatch_error"],
    },
    {
      prefix: "platform.task_center.execution_process_lock.",
      resourceI18nKey: "common.errors.apiCodeResources.platformTaskCenterExecutionProcessLock",
      reasonCodes: ["acquire_failed", "release_failed"],
    },
    {
      prefix: "platform.tools_library.tool.",
      resourceI18nKey: "common.errors.apiCodeResources.platformToolsLibraryTool",
      reasonCodes: ["create_failed_after_asset_upload"],
    },
    {
      prefix: "platform.vulnerability_library.business_event.",
      resourceI18nKey: "common.errors.apiCodeResources.platformVulnerabilityLibraryBusinessEvent",
      reasonCodes: ["consumer_loop_failed", "outbox_claim_failed", "publish_failed"],
    },
    {
      prefix: "redblue.business_event.",
      resourceI18nKey: "common.errors.apiCodeResources.redblueBusinessEvent",
      reasonCodes: ["outbox_claim_failed", "publish_failed"],
    },
    {
      prefix: "redblue.scheme_topology_sync.",
      resourceI18nKey: "common.errors.apiCodeResources.redblueSchemeTopologySync",
      reasonCodes: ["role_nodes_missing", "seats_missing"],
    },
  ];
